"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bifrost_number_1 = require("@bifrost-platform/bifrost-number");
const BifiTokenList_1 = require("./BifiTokenList");
const constant_1 = require("./constant");
class BifiCurrency {
    constructor(tokens, currency = 'usd') {
        this.tokens = new BifiTokenList_1.default(tokens, this.callListener.bind(this));
        this.callbackMapping = new Map();
        this._selectedKey = currency;
    }
    get selectedKey() {
        return this._selectedKey;
    }
    set selectedKey(value) {
        if (this._selectedKey === value) {
            return;
        }
        this._selectedKey = value;
        this.callListener('currency');
    }
    setListener(key, callback) {
        this.callbackMapping.set(key, callback);
    }
    removeListener(key) {
        this.callbackMapping.delete(key);
    }
    callListener(key) {
        const callback = this.callbackMapping.get(key);
        if (typeof callback === 'function') {
            callback();
        }
        if (this.callbackMapping.has(key)) {
            this.callbackMapping.get(key)();
        }
    }
    getCurrency() {
        return this.selectedKey;
    }
    setCurrency(key) {
        if (this.tokens.hasToken(key)) {
            this.selectedKey = key;
        }
    }
    getDefaultDecimals() {
        return constant_1.DEFAULT_DECIMALS;
    }
    getFormatedValue(value, key) {
        return new bifrost_number_1.default(value).div(new bifrost_number_1.default('10').pow(this.tokens.getToken(key).decimals));
    }
    getUnformatedValue(value, key) {
        return new bifrost_number_1.default(value).mul(new bifrost_number_1.default('10').pow(this.tokens.getToken(key).decimals));
    }
    getBalanceFormatedTokenValue(value, fromKey = this.selectedKey, toKey = this.selectedKey, replaceString = this.tokens.getToken(toKey).replaceString, decimalLimit, lengthLimit, showDecimalZero, comma) {
        value = new bifrost_number_1.default(value);
        return this.getFormatedTokenValue(value, fromKey, toKey).balanceFormat(replaceString, decimalLimit, lengthLimit, showDecimalZero, comma);
    }
    getWordFormatedValue(value, locale, replaceString, decimalLimit = 2, showDecimalZero = false, comma) {
        let result = '';
        let calcValue = new bifrost_number_1.default(value);
        let unit = '';
        if (locale === 'ko') {
            let secondCalcValue;
            let secondUnit = '';
            if (calcValue.gte('100000000000000000000')) {
                calcValue = calcValue.div('100000000000000000000');
                unit = '해';
                if (calcValue.gte('1.0001')) {
                    secondCalcValue = calcValue.minus(calcValue.idiv('1')).mul('10000');
                    secondUnit = '경';
                }
            }
            else if (calcValue.gte('10000000000000000')) {
                calcValue = calcValue.div('10000000000000000');
                unit = '경';
                if (calcValue.gte('1.0001')) {
                    secondCalcValue = calcValue.minus(calcValue.idiv('1')).mul('10000');
                    secondUnit = '조';
                }
            }
            else if (calcValue.gte('1000000000000')) {
                calcValue = calcValue.div('1000000000000');
                unit = '조';
                if (calcValue.gte('1.0001')) {
                    secondCalcValue = calcValue.minus(calcValue.idiv('1')).mul('10000');
                    secondUnit = '억';
                }
            }
            else if (calcValue.gte('100000000')) {
                calcValue = calcValue.div('100000000');
                unit = '억';
                if (calcValue.gte('1.0001')) {
                    secondCalcValue = calcValue.minus(calcValue.idiv('1')).mul('10000');
                    secondUnit = '만';
                }
            }
            else if (calcValue.gte('10000')) {
                calcValue = calcValue.div('10000');
                unit = '만';
                if (calcValue.gte('1.0001')) {
                    secondCalcValue = calcValue.minus(calcValue.idiv('1')).mul('10000');
                }
            }
            if (secondCalcValue && secondCalcValue instanceof bifrost_number_1.default && secondCalcValue.gt('0')) {
                result = `${calcValue.balanceFormat(`{} ${unit}`, 0, undefined, false, comma)} ${secondCalcValue.balanceFormat(`{} ${secondUnit}`, secondUnit ? decimalLimit : 0, undefined, secondUnit ? showDecimalZero : undefined, comma)}`;
            }
            else {
                result = calcValue.balanceFormat(`{} ${unit}`, decimalLimit, undefined, showDecimalZero, comma);
            }
        }
        else {
            if (calcValue.gte('1000000000000000')) {
                calcValue = calcValue.div('1000000000000000');
                unit = 'Q';
            }
            else if (calcValue.gte('1000000000000')) {
                calcValue = calcValue.div('1000000000000');
                unit = 'T';
            }
            else if (calcValue.gte('1000000000')) {
                calcValue = calcValue.div('1000000000');
                unit = 'B';
            }
            else if (calcValue.gte('1000000')) {
                calcValue = calcValue.div('1000000');
                unit = 'M';
            }
            else if (calcValue.gte('1000')) {
                calcValue = calcValue.div('1000');
                unit = 'K';
            }
            result = calcValue.balanceFormat(`{} ${unit}`, decimalLimit, undefined, showDecimalZero, comma);
        }
        if (replaceString) {
            result = replaceString.replace('{}', result);
        }
        if (result && typeof result === 'string') {
            result = result.trim();
        }
        return result;
    }
    getFormatedTokenValue(value, fromKey = this.selectedKey, toKey = this.selectedKey) {
        value = new bifrost_number_1.default(value);
        if (fromKey !== toKey) {
            try {
                value = value.mul(this.tokens.getToken(fromKey).price).div(this.tokens.getToken(toKey).price);
            }
            catch (error) {
            }
        }
        return value;
    }
    getTokenList() { return this.tokens.getTokenList(); }
    ;
    getTokenIndex(key) { return this.tokens.getTokenIndex(key); }
    ;
    getToken(key) { return this.tokens.getToken(key); }
    ;
    hasToken(key) { return this.tokens.hasToken(key); }
    ;
    getDefaultToken(key) { return this.tokens.getDefaultToken(key); }
    setToken(key, price, decimals, address, title, symbol, unit, replaceString, image, color) { this.tokens.setToken(key, price, decimals, address, title, symbol, unit, replaceString, image, color); }
    setTokenPrice(key, price) { this.tokens.setTokenPrice(key, price); }
    setTokenDecimals(key, decimals) { this.tokens.setTokenDecimals(key, decimals); }
    setTokenAddress(key, address) { this.tokens.setTokenAddress(key, address); }
}
exports.default = BifiCurrency;
;
//# sourceMappingURL=index.js.map